import fp from 'lodash/fp';

import { allowedOids } from '../../constants';


const sign = (element, registered) => {
    if (!(element.oid in allowedOids))
        return 'nonGostCertificate';

    if (fp.some({ Thumbprint: element.thumbprint, IsDeleted: true }, registered))
        return 'deletedCertificate';

    if (!fp.some({ Thumbprint: element.thumbprint }, registered))
        return 'notAddedCertificate';

    return null;
};

const addToProfile = (element, registered) => {
    if (!(element.oid in allowedOids))
        return 'nonGostCertificate';

    if (fp.pipe(
        fp.reject(fp.get('IsDeleted')),
        fp.some({ Thumbprint: element.thumbprint }),
    )(registered))
        return 'alreadyAddedCertificate';

    return null;
};

export const certificateFilters = {
    sign,
    addToProfile,
};
